<template>
    <div>
        <vs-dialog width="550px" not-center v-model="active">
            <template #header>
                <h4>
                    Facturar
                </h4>
            </template>
            <div class="con-content">
                <div v-if="rows && rows.factura">
                    <p><small>FOLIO: </small><strong>{{rows.factura.folio}}</strong></p>
                    <p><small>IMPORTE: </small><strong>{{rows.factura.importe}}</strong></p>
                    <p><small>FECHA: </small><strong>{{rows.factura.fecha}}</strong></p>
                    <p><small>MÉTODO DE PAGO: </small><strong>{{rows.factura.metodo_pago}}</strong></p>
                    <p><small>CONCEPTO(S):</small></p>
                    <div v-for="(concepto, i) in rows.factura.conceptos" :key="i" class="ml-3">
                        <p class="mb-0"><small>NOMBRE: </small><strong>{{concepto.nombre}}</strong></p>
                        <p class="mb-0"><small>MONTO: </small><strong>{{concepto.monto}}</strong></p>
                        <p class="mb-0"><small>FECHA DE PAGO: </small><strong>{{concepto.fecha_pago}}</strong></p>
                        <hr v-if="rows.factura.conceptos.length > 1">
                    </div>
                </div>
            </div>

            <template #footer>
            <div class="con-footer" style="display: flex; justify-content: center;">
                <vs-button danger @click="active = false">
                    Cancelar
                </vs-button>
                <vs-button :loading="loadingFacturar" success @click="facturarPagos()">
                    Aceptar
                </vs-button>
            </div>
            </template>
        </vs-dialog>
    </div>
</template>

<script>
import cobranza from '../../../../../api/requests/cobranza-persona.js'
export default {
    props:[
      'value',
      'rows',
      'institucion'
    ],
    data(){
        return{
            active: false,
            loadingFacturar: false
        }
    },
    methods:{
        
        async facturarPagos () {
            const vm = this
            const infoPago = []
            const conceptos = vm.rows.factura.conceptos
            conceptos.forEach(i => {
                infoPago.push(i.id)
            })
            let params = {
                id: vm.rows.persona.id,
                ciclo_escolar: vm.rows.factura.conceptos[0].ciclo_escolar_id,
                institucion: this.institucion,
                pagos : infoPago
            }
            try {
                this.loadingFacturar = true
                const { data: response = null } = await cobranza.postFacturar(params) 
                // { data: { uuids: ['1','2','3'] } }
                || {}
                this.$emit('endLoading')
                console.log(response)
                if (response && response.mensaje_exitoso ){
                    this.$vs.notification({
                        progress: 'auto',                           
                        color: 'success',
                        position: null,
                        title: 'UUID facturado',
                        text: response.mensaje_exitoso
                    })                                
                    this.active = false
                    this.$emit('refreshTable',true)
                    
                }else {            
                    this.active = false
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Error',
                        text: response.mensaje_error
                    })
                }
                this.loadingFacturar = false
                
            } catch (error) {
                this.loadingFacturar = false
                console.log(error)
                this.$emit('endLoading')
                    if (error.response.data && error.response.data.errores){
                    const data = error.response.data.errores
                    if (data.descripcion){
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: data.descripcion
                        })
                    }
                }else{
                    this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Error',
                    text: `Algo salió mal`
                    })
                }
            }
        },
    },
    watch: {
        value (val) {
            this.active = val
        },    
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        }
    }
}
</script>